import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { FancyShareApi } from 'api/ApiHelper';
import { ResponseDto } from '@diritto/common/base/response.dto';

type DeleteFancyShareVariables = { fancyShareId: number };

export const useDeleteFancyShareMutation = (
  options?: UseMutationOptions<ResponseDto, unknown, DeleteFancyShareVariables>,
) =>
  useMutation({
    mutationFn: ({ fancyShareId }: DeleteFancyShareVariables) => FancyShareApi.deleteFancyShare(fancyShareId),
    ...options,
  });
